/* Cali cart drawer "Pairs well with"
   Loads sections/cali-drawer-upsell.liquid into the drawer and refreshes it
   whenever the drawer's cart is updated (add, quantity change, remove). */
(function () {
  if (window.CaliCartUpsell) return;

  var SECTION = 'cali-drawer-upsell';
  var timer = null;
  var lastKey = null;

  function slot() {
    return document.querySelector('[data-cali-upsell]');
  }

  function refresh(cart, delay) {
    var el = slot();
    if (!el) return;
    clearTimeout(timer);

    if (cart && cart.items && cart.items.length === 0) {
      el.innerHTML = '';
      el.hidden = true;
      lastKey = null;
      return;
    }

    // Skip the request when the cart contents did not change
    var key = cart && cart.items
      ? cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',')
      : null;
    if (key && key === lastKey) return;

    timer = setTimeout(function () {
      var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + '?sections=' + SECTION;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (!json || !json[SECTION]) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = json[SECTION];
          var inner = tmp.querySelector('[data-cali-upsell-inner]');
          var html = inner ? inner.innerHTML.trim() : '';
          el.innerHTML = html;
          el.hidden = html === '';
          if (key) lastKey = key;
        })
        .catch(function () {});
    }, delay || 0);
  }

  function hookDrawer() {
    var drawer = window.wetheme && window.wetheme.drawer;
    if (!drawer || drawer.__caliUpsellHooked) return !!drawer;
    var original = drawer.updateCartDrawer;
    if (typeof original !== 'function') return false;

    var wrapped = function (cart) {
      var result = original.apply(this, arguments);
      // Small delay after a one-tap add so "✓ Added" is visible before it swaps
      refresh(cart, 1200);
      return result;
    };
    drawer.updateCartDrawer = wrapped;
    drawer._updateCartDrawer = wrapped;
    drawer.__caliUpsellHooked = true;
    return true;
  }

  function init() {
    var tries = 0;
    (function wait() {
      if (hookDrawer() || tries++ > 40) {
        var initial = document.getElementById('initial-cart');
        var cart = null;
        try { cart = initial ? JSON.parse(initial.textContent) : null; } catch (e) {}
        refresh(cart, 0);
        return;
      }
      setTimeout(wait, 150);
    })();
  }

  document.addEventListener('cart:added', function () { lastKey = null; });

  window.CaliCartUpsell = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
